<button type="button" class="ut-btn ut-btn--secondary ut-btn--sm" [attr.aria-label]="'Share: ' + (text | emojiText)" [cdkMenuTriggerFor]="shareMenu">
  <span class="material-icons" aria-hidden="true">share</span>
  Share
</button>
<ng-template #shareMenu>
  <div class="menu" cdkMenu>
    <button type="button" class="menu__item" cdkMenuItem (cdkMenuItemTriggered)="copyLink()">
      <span class="material-icons" aria-hidden="true">link</span>Copy link
    </button>
    <button type="button" class="menu__item" cdkMenuItem (cdkMenuItemTriggered)="shareOn('x')">
      <span class="material-icons" aria-hidden="true">open_in_new</span>Share on X
    </button>
    <button type="button" class="menu__item" cdkMenuItem (cdkMenuItemTriggered)="shareOn('linkedin')">
      <span class="material-icons" aria-hidden="true">open_in_new</span>Share on LinkedIn
    </button>
    @if (canUseDeviceShare) {
      <button type="button" class="menu__item" cdkMenuItem (cdkMenuItemTriggered)="deviceShare()">
        <span class="material-icons" aria-hidden="true">more_horiz</span>More options
      </button>
    }
  </div>
</ng-template>
<span class="sr-only" role="status">{{ status() }}</span>
